export const NotificationDateMap = {
    'recent': 'Gerade eben',
    'minutes_ago': 'vor <X> Minute<n>',
    'hours_ago': 'vor <X> Stunde<n>',
    'days_ago': 'vor <X> Tag<en>',
    'weeks_ago': 'vor <X> Woche<n>',
    'months_ago': 'vor <X> Monat<en>'
}